<template>
	<SlidingPagination
		:current='currentPage'
		:total='totalPages'
		@page-change='onPageChange'
		class='journal-lpo__pagination'
	/>

<!-- 	<p-paginator
		:first='3'
		:rows='perPage'
		:totalRecords='totalRows'
	/> -->
</template>

<script>

import SlidingPagination from 'vue-sliding-pagination';

import { mapState, mapGetters, mapActions } from 'vuex';

export default {
	name: 'JournalLpo__pagination',

	components: {
	  SlidingPagination
	},

	computed: {
		...mapState('journalLpo', {
			currentPage: state => state.currentPage,
			perPage: state => state.perPage
		}),

		...mapGetters('journalLpo', [
			'totalPages',
			'totalRows'
		])
	},

	methods: {
		onPageChange(page) {
			this.$store.dispatch('journalLpo/changePage', page);
		},
	}
};

</script>

<style scoped>
.journal-lpo__pagination >>> .c-sliding-pagination {
	/*pointer-events: all*/
}

.journal-lpo__pagination >>> .c-sliding-pagination__list {
	/*display: inline;*/
	/*margin: 0;*/
	/*padding: 0*/
}

.journal-lpo__pagination >>> .c-sliding-pagination__list-element {
	display: inline-block;
	background: #3D916F;
	color: #fff;
	padding: 0.24rem 0.5rem;
	border-radius: 0.2rem;
	/*margin: 0;*/
	margin-right: 0.3rem;
	/*margin-bottom: 1em;*/
	transition-duration: 300ms;
	transition-property: background, color;

	text-align: center;

	/*display: flex;*/

	/*height: 30px;*/
	/*width: 34px;*/
}

.journal-lpo__pagination >>> .c-sliding-pagination__list-element:hover {
	transition-duration: 300ms;
	transition-property: background, color;
	color: #e9e9e9;
	background: #2CC185
}

.journal-lpo__pagination >>> .c-sliding-pagination__list-element:last-child {
	margin-right: 0
}

.journal-lpo__pagination >>> .c-sliding-pagination__list-element--active {
	background: #2CC185;
	color: #e9e9e9
}

.journal-lpo__pagination >>> .c-sliding-pagination__list-element--active:hover {
	color: #fff;
	background: #2CC185;
	cursor: default
}

.journal-lpo__pagination >>> .c-sliding-pagination__list-element--disabled {
	background: none;
	color: inherit;
	cursor: not-allowed
}

.journal-lpo__pagination >>> .c-sliding-pagination__page {
	color: inherit;
	padding: 0;
	margin: 0;
	text-decoration: none
}

.journal-lpo__pagination >>> .c-sliding-pagination__page[disabled] {
	pointer-events: none;
	cursor: not-allowed
}

</style>